var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorToast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#D5D5D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 43738"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.5,
    y: -153.5,
    width: 542,
    height: 511,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant2",
    filter: "url(#filter0_d_8099_76293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -11,
    width: 419,
    height: 103,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 43743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C19.4037 25 25 19.4037 25 12.5C25 5.59625 19.4037 0 12.5 0C5.59625 0 0 5.59625 0 12.5C0 19.4037 5.59625 25 12.5 25ZM10.625 18.7387C10.625 17.655 11.4488 16.875 12.4888 16.875C13.5513 16.875 14.375 17.655 14.375 18.7387C14.375 19.8225 13.5513 20.625 12.4888 20.625C11.4488 20.625 10.625 19.8225 10.625 18.7387ZM11.465 5C11.3807 5.00009 11.2972 5.01724 11.2197 5.05043C11.1422 5.08362 11.0721 5.13216 11.0139 5.19312C10.9556 5.25409 10.9102 5.32621 10.8806 5.40516C10.8509 5.48411 10.8375 5.56824 10.8413 5.6525L11.2238 14.4025C11.2308 14.5634 11.2998 14.7154 11.4163 14.8268C11.5327 14.9381 11.6876 15.0002 11.8488 15H13.1525C13.3136 15.0002 13.4685 14.9381 13.585 14.8268C13.7014 14.7154 13.7704 14.5634 13.7775 14.4025L14.1587 5.6525C14.1625 5.56814 14.149 5.4839 14.1193 5.40487C14.0896 5.32584 14.0441 5.25365 13.9857 5.19267C13.9273 5.13169 13.8571 5.08318 13.7795 5.05006C13.7018 5.01695 13.6182 4.99992 13.5337 5H11.465Z",
    fill: "#DB3D14"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8099_76293",
    x: -24,
    y: -15,
    width: 427,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8099_76293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8099_76293",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToast);
export default __webpack_public_path__ + "static/media/error-toast.ccb245552d09fb1784501f6676197d22.svg";
export { ForwardRef as ReactComponent };